import { render } from "./LogoIcon.vue?vue&type=template&id=54a61941&scoped=true"
import script from "./LogoIcon.vue?vue&type=script&lang=js"
export * from "./LogoIcon.vue?vue&type=script&lang=js"

import "./LogoIcon.vue?vue&type=style&index=0&id=54a61941&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a61941"]])

export default __exports__